// https://material-ui.com/api/snackbar/
// https://material-ui.com/api/alert/

import React from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import withShowToast from '../../hocs/with_show_toast.js';
import { compose } from 'redux';

import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const styles = theme => ({
  root: {
    position: "absolute",
    left: "0px",
    right: "0px",
    bottom: "0px",
  },
});

// TODO: Add documentation
class ToastContainer extends React.Component {

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    this.state = {

    }
  }

  static getDerivedStateFromProps(props, state) {
    const { toastShowed, toast } = props;

    return {
      toast: toast,
      toastShowed: toastShowed
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state.toastShowed) !== JSON.stringify(nextState.toastShowed) ||
           JSON.stringify(this.state.toast) !== JSON.stringify(nextState.toast);
  }

  onClick() {
    const { toastContext } = this.props;
    toastContext.hideToast();
  }

  render() {
    const { toastContext, classes } = this.props;
    const { toastShowed, toast } = this.state;

    return <div className = { classes.root } >
      <Snackbar open = { toastShowed }
                      onClose = { toastContext.onToastHidden }
                      onClick = { this.onClick }
                      anchorOrigin = {
                        { 
                          vertical: 'bottom', 
                          horizontal: 'center'
                        } }
                      autoHideDuration = { 5000 } >
        {
          toast &&
          <Alert severity = { toast.type }
                variant = { "filled" } 
                action = { <React.Fragment /> } >
            { toast.message }
          </Alert>
        }
      </Snackbar>
    </div>
  }
}

export default compose(withRouter, withShowToast, withStyles(styles))(ToastContainer)

